<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { type Component } from "@/global";
import { inject, provide, reactive, ref } from "vue";

const cmp = inject<Component>("component")!;
const obj = cmp.control.slots!.default!.reduce<Record<string, any>>(
  (data, cmp) => {
    if (cmp.control.props.prop) {
      data[cmp.control.props.prop] = undefined;
    }
    return data;
  },
  {}
);

const model = reactive<Record<string, any>>(obj);
provide("formModel", model);

const refForm = ref();
async function validate(prop?: string) {
  const { valid } = await refForm.value.validate(prop);
  return valid;
}

provide("validate", validate);

defineExpose({ model, validate });
</script>
<template>
  <nut-form class="mp-form" ref="refForm" :modelValue="model" v-bind="$attrs">
    <slot />
  </nut-form>
</template>
<style lang="scss">
.mp-form .nut-cell-group__wrap {
  margin: 0 !important;
}
</style>
